import React, { useState, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import BreadCrumbs from '../Common/BreadCrumbs';
import AddButton from '../Common/AddButton';
import Routes from '../../routes';
import OpenWorkOrders from './OldestOpenWorkOrders';
import TechnicianServiceHistory from './TechnicianServiceHistory';
import './Dashboard.css';
import Loading from '../Loading';
import PageTitleWithToolTip from '../Common/PageTitleWithTooltip';
import UserInfo from '../../UserInfo';
import useNavigate from '../../hooks/useNavigate';
import useBreadCrumbs from '../../hooks/useBreadCrumbs';
import { isMobile } from '../../utils';

const HomePage = ({
    history
}) => {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate({
        pageName: 'Home'
    });
    useBreadCrumbs({
        path: { id: 'Home', text: 'Home', link: history.location.pathname, reset: true }
    });

    useEffect(() => {

        const fetchData = async () => {
            //Later used for authorization/login
            //const token = await authService.getAccessToken();
            const response = await fetch(Routes.Dashboard.Get()
                //  , {headers: !token ? {} : { 'Authorization': `Bearer ${token}` }}
            );
            const data = await response.json();
            setLoading(false);

        };

        fetchData();
    }, []);

    const userPermission = UserInfo.isSystemOwner() &&
        (UserInfo.isSuperTenantAdmin() ||
        UserInfo.isTenantAdministrator() ||
        UserInfo.isRegionalAdministrator() ||
        UserInfo.isTechnicianManager() ||
        UserInfo.isTechnician()) ; 

    if (loading) {
        return (
            <Loading />
        );
    }
    
     return (
         <Box sx={{
             padding: { xs: '0px', sm: '8px', lg: 0 } // Add back small padding on mobile if needed
         }}>
            <BreadCrumbs
                path={[
                    { text: 'Home' }
                ]}
                sx={{ display: { xs: 'none', lg: 'block' } }}
            />
            <Grid
                container
                direction="row"
                alignItems="center"
            >
                <Grid item xs={12} sm={6} md={6} lg={6}>
                    <div className='complianceCenterDemo'>
                        <PageTitleWithToolTip
                            pageTitle="Home"
                            toolTipText={isMobile ? undefined : "Use the dashboard to stay up to date on the impact from your maintenance work and to assist in compliance management."}
                            sx={{
                                whiteSpace: 'nowrap',
                                marginTop: 3,
                                px: { xs: 2, sm: 0}
                            }}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-end' }, alignItems: 'center' }}>
                    {
                        userPermission && (
                            <AddButton
                                sx={{
                                    width: { xs: '100%', sm: 'auto' }
                                }}
                                text="Create Work Order"
                                onClick={() => navigate.push('/CreateWorkOrder')}
                            />
                        )
                    }
                </Grid>

                <Grid item xs={12} mt={2}>
                    <TechnicianServiceHistory hasNoPermission={userPermission} />
                </Grid>
                <Grid item xs={12} mt={2}>
                    <OpenWorkOrders
                        hasNoPermission={userPermission}
                        history={navigate}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default HomePage;
